import { Icon } from '@/components/Icon';
import styles from './FaqItem.module.css';

import keyboardArrowDownSvg from '../../assets/icons/keyboard-arrow-down.svg?raw';

type FaqItemProps = {
  id: string;
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
};

export function FaqItem({ id, question, answer, isOpen, onToggle }: FaqItemProps) {
  return (
    <article className={styles.root}>
      <button
        className={styles.trigger}
        type="button"
        aria-expanded={isOpen}
        aria-controls={`${id}-content`}
        onClick={() => {
          onToggle();
        }}
      >
        <span className={styles.question}>{question}</span>
        <Icon
          svg={keyboardArrowDownSvg}
          size={24}
          glyphWidth={11.15}
          glyphHeight={6.55}
          color="var(--content-primary)"
          className={isOpen ? styles.chevronOpen : styles.chevron}
        />
      </button>
      {isOpen ? (
        <div className={styles.content} id={`${id}-content`}>
          <p className={styles.answer}>{answer}</p>
        </div>
      ) : null}
    </article>
  );
}
